import React from "react";
import style from "./HomeworkLayout.module.scss";

interface HomeworkLayoutProps {
    left: React.ReactNode;
    main: React.ReactNode;
}

export default function HomeworkLayout({ left, main }: HomeworkLayoutProps) {
    return (
        <div className={style.root}>
            <div className="container">
                <div className={style.wrapper}>
                    <div className={style.left}>{left}</div>

                    <div className={style.main}>{main}</div>
                </div>
            </div>
        </div>
    );
}
